<template>
  <div class="main">
    <notifications></notifications>
    <div class="logo">
      <img src="/img/link3-logo.png">
    </div>
    <div class="form">
      <div class="title">
        User login
        <div class="bar"></div>
      </div>
      <p v-if="$route.query.scope === 'actions'">
        By signing in, you are authorizing Google to control your devices.
      </p>
      <div class="input-box top-box">
        <input type="text" id="phone_email" v-model="account" placeholder="Email">
      </div>
      <div class="input-box">
        <input :type="show?'text' :'password'" id="passwd" v-model="passwd" placeholder="Password">
        <i v-if="show" @click="toggleShow" class="show-icon">
          <svg t="1690854746816" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1669" width="200" height="200"><path d="M190.6688 360.3456C269.8752 294.7072 383.488 225.28 512 225.28s242.1248 69.4272 321.28 135.0656a911.9232 911.9232 0 0 1 120.576 121.2928l6.8608 8.6528 1.2288 1.536 0.6144 0.8192 0.512 0.6656 0.1536 0.2048v0.0512s0.0512 0.0512-24.576 18.432c24.6272 18.3808 24.6272 18.3808 24.576 18.432l-0.1536 0.256-0.512 0.6656a847.4624 847.4624 0 0 1-8.704 11.008 911.3088 911.3088 0 0 1-120.5248 121.2928C754.0736 729.2928 640.512 798.72 512 798.72s-242.1248-69.4272-321.3312-135.0656a910.9504 910.9504 0 0 1-120.5248-121.344 510.2592 510.2592 0 0 1-8.704-10.9568l-0.512-0.6656-0.1536-0.2048v-0.1024l24.576-18.432-24.6272-18.3296 0.0512-0.1024 0.1536-0.2048 0.512-0.6656a312.5248 312.5248 0 0 1 8.704-11.008 911.5648 911.5648 0 0 1 120.5248-121.2928zM85.3504 512l-24.6272-18.432-13.7216 18.432 13.7216 18.432 24.576-18.432z m39.424 0a850.7392 850.7392 0 0 0 105.1648 104.3456C305.152 678.7072 404.8384 737.28 512 737.28c107.1104 0 206.848-58.5728 282.112-120.9344A850.7904 850.7904 0 0 0 899.2256 512a850.176 850.176 0 0 0-105.1136-104.3456C718.848 345.2928 619.1104 286.72 512 286.72c-107.1104 0-206.848 58.5728-282.112 120.9344A850.176 850.176 0 0 0 124.7744 512z m813.8752 0l24.576 18.432 13.7728-18.432-13.7216-18.432-24.576 18.432z" fill="#747690" p-id="1670"></path><path d="M374.6304 512a137.3696 137.3696 0 1 1 274.7392 0 137.3696 137.3696 0 0 1-274.7392 0zM512 436.0704a75.9296 75.9296 0 1 0 0 151.9104 75.9296 75.9296 0 0 0 0-151.9104z" fill="#747690" p-id="1671"></path></svg>
        </i>
        <i v-if="!show" @click="toggleShow" class="hide-icon">
          <svg t="1690854726523" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1526" width="200" height="200"><path d="M168.7552 436.6848c-28.7744-23.552-52.224-50.7904-67.9936-81.152l54.4768-28.3648c11.264 21.6576 28.8768 42.6496 52.4288 61.952C274.2272 443.8016 384.512 481.28 512 481.28c127.488 0 237.7216-37.5296 304.3328-92.16 23.552-19.3024 41.1136-40.2944 52.4288-61.952l54.4768 28.3648c-15.7696 30.3616-39.2704 57.6-67.9936 81.152C775.168 502.272 649.9328 542.72 512 542.72c-137.984 0-263.168-40.3968-343.2448-106.0352" fill="#747690" p-id="1527"></path><path d="M632.6784 684.8l-44.1856-164.864 59.392-15.872 44.1344 164.864-59.3408 15.872zM895.8464 597.9648L775.168 477.2864l43.4176-43.4688 120.6784 120.6784-43.4176 43.4688zM249.088 477.2864l-120.6784 120.6784-43.4688-43.4688 120.6784-120.6784 43.4688 43.4688zM434.944 519.936l-44.1344 164.864-59.392-15.872 44.1856-164.864 59.392 15.872z" fill="#747690" p-id="1528"></path></svg>
        </i>
      </div>
      <div class="input-box submit-button" @click="submit">
        Login
      </div>
    </div>
    <div class="bottom-bar"></div>
  </div>
</template>
<script>
export default {
  created(){
    document.getElementsByTagName("title")[0].text = "Auth login";
  },
  data() {
    return {
      account : "",
      passwd : "",
      show: false,
    };
  },
  methods: {
    toggleShow(){
      this.show = !this.show;
    },
    submit (){
      if(this.account == ""){
        this.$errorMsg("Account does not exist")
        return 
      }
      if(this.passwd == ""){
        this.$errorMsg("Wrong password")
        return
      }
      var query = {...this.$router.history.current.query}
      this.$api.other_api_authCloud({
        "type": 3,
        "key": query.client_id,
        "client_id": query.scope,
        "client_type": 21,
      })
        .then(this.$Then(res => {
          return this.$api.other_api_authLogin({
            user_id: this.account,
            ver_type : 0,
            ver_code: "",
            area_code: "",
            user_passwd: this.passwd,
            enc_type : 2,
            type: 2,
            auto_signup: 2,
            acc_token: res.data.token,
          })
        }))
        .then(this.$Then(res => {
          window.location.href = decodeURIComponent(query.redirect_uri) + `?state=${query.state}&code=${res.data.auth_code}`
        }))
        .catch(err => {
          console.error(err)
          if(err.code == 400){
            this.$errorMsg("Parameter error")
          } else if(err.code == 406){
            this.$errorMsg("Account does not exist")
          } else if(err.code == 512){
            this.$errorMsg("Wrong password")
          } else {
            this.$errorMsg("Failed to obtain info.")
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped>
  .main{
    font-family: 黑体;
    width: 100vw;
    height: 100vh;
    background: url("/img/bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
  .logo{
    margin-bottom: 15pt;
    & img{
      height: 56pt;
    }
  }    
  .form{
    margin: 0 24pt;
    border-radius: 10pt;
    padding: 23pt 20pt;
    background: #ffffff;
    text-align: center;
    width: calc( 100% - 48pt );
    max-width: 480pt;
  }
  .title{
    margin-bottom: 0;
    color: #212833;
    font-size: 16pt;
    padding-bottom: 4pt;
    display: inline-block;
    margin-top: 0;
    font-weight: 600;
  }
  .bar{
    height: 3pt;
    background: #FDC612;
    margin: 10pt 5pt 0;
  }
  .top-box{
    margin-top: 20pt;
  }
  input, .input-box.submit-button{
    width: 100%;
    line-height: 36pt;
    height: 36pt;
    border-radius:  8pt;
    background: #F7F8FA;
    margin-bottom: 16pt;
    border: none;
    font-size: 14pt;
    padding-left: 16pt;
  }
  .input-box.submit-button{
    line-height: 36pt;
    height: 36pt;
    background: #FDC612;
    color:#FFFFFF;
    padding-left: 0;
  }
  .input-box{
    position: relative;
  }
  .show-icon svg, .hide-icon svg{
    width: 20pt;
    height: 20pt;
    position: absolute;
    right: 10pt;
    top: 13pt;
  }
</style>